import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../AppIcon';
import Button from '../../../ui/Button';

const QuickActions = ({ actions }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
        <Icon name="Zap" size={20} className="text-accent" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {actions?.map((action, index) => (
          <div key={index}>
            {action?.path ? (
              <Link to={action?.path} className="block">
                <Button
                  variant={action?.variant || 'outline'}
                  fullWidth
                  iconName={action?.icon}
                  iconPosition="left"
                  iconSize={16}
                  className="justify-start h-12"
                >
                  <div className="text-left">
                    <div className="font-medium">{action?.title}</div>
                    <div className="text-xs text-muted-foreground">{action?.description}</div>
                  </div>
                </Button>
              </Link>
            ) : (
              <Button
                variant={action?.variant || 'outline'}
                fullWidth
                iconName={action?.icon}
                iconPosition="left"
                iconSize={16}
                onClick={action?.onClick}
                className="justify-start h-12"
              >
                <div className="text-left">
                  <div className="font-medium">{action?.title}</div>
                  <div className="text-xs text-muted-foreground">{action?.description}</div>
                </div>
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;